import axios, { AxiosRequestConfig } from 'axios';

export type HttpServiceResult<T = any> =
  | {
      success: true;
      data: T;
      error?: undefined;
    }
  | { success: false; data?: undefined; error: string };

export interface RequestParams {
  method: 'get' | 'put' | 'post' | 'delete';
  url: string;
  data?: any;
  query?: any;
  headers?: any;
  signal?: AbortSignal;
}

export class HttpService {
  static set AccessToken(val: string | undefined) {
    this.accessToken = val;
  }
  private static accessToken?: string;

  protected send<T>(params: RequestParams): Promise<T> {
    params.headers = params.headers || {};
    if (!params.url.startsWith('http') && !params.headers['authorization'] && HttpService.accessToken) {
      params.headers['authorization'] = HttpService.accessToken;
    }
    const path = params.url.startsWith('http') ? params.url : import.meta.env.VITE_API_HOST + params.url;
    const config: AxiosRequestConfig = {
      url: path,
      data: params.data,
      params: params.query,
      headers: params.headers,
      method: params.method,
      signal: params.signal,
    };
    return axios.request(config).then((res) => res.data);
  }
}
